/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { Table, Collapse, Row, Col, Card } from "antd";

const RateComission = ({ commission }) => {
  const { Panel } = Collapse;
  const [rateCommission, setRateCommission] = useState([]);

  useEffect(() => {
    getAllCommission();
  }, [commission]);

  const getAllCommission = async () => {
    const transformCharge = (current, past) => ({
      ...current,
      PastrateType: past?.rateType,
      pastchargesHead: past?.chargesHead,
      slab: current?.slab?.map((e, index) => ({
        ...e,
        pastMinValue: past?.slab?.[index]?.minValue,
        pastMaxValue: past?.slab?.[index]?.maxValue,
        pastValue: past?.slab?.[index]?.value,
        slabRateType: current?.rateType,
        pastSlabRateType: past?.rateType,
      })),
    });

    setRateCommission(
      commission?.current?.map((item, i) =>
        transformCharge(item, commission?.past?.[i] || null)
      )
    );
    //setRateCommission(commission);
  };

  const columns = [
    {
      title: "Min Value",
      dataIndex: "minValue",
      render: (text, record) => (
        <>
          {record?.pastMinValue && record?.pastMinValue !== text ? (
            <span className="high-light">
              <span>{text}</span>
              <span className="ml-05 past-val">{record?.pastMinValue}</span>
            </span>
          ) : (
            <span>{text}</span>
          )}
        </>
      ),
    },
    {
      title: "Max Value",
      dataIndex: "maxValue",
      render: (text, record) => (
        <>
          {record?.pastMaxValue && record?.pastMaxValue !== text ? (
            <span className="high-light">
              <span>{text}</span>
              <span className="ml-05 past-val">{record?.pastMaxValue}</span>
            </span>
          ) : (
            <span>{text}</span>
          )}
        </>
      ),
    },
    {
      title: "Rate",
      dataIndex: "value",
      render: (text, record) => {
        const hasPastValue =
          commission?.past &&
          (record?.slabRateType !== record?.pastSlabRateType ||
            text !== record?.pastValue);

        return hasPastValue ? (
          <span className="high-light">
            {record?.slabRateType?.toLowerCase() === "fixed" ? (
              <span>{text}</span>
            ) : (
              <span>{text}%</span>
            )}
            <span className="ml-05 past-val">
              {record?.past?.slabRateType?.toLowerCase() === "fixed" ? (
                <span className="high-light">{record?.pastValue}</span>
              ) : (
                <span className="high-light">{record?.pastValue}%</span>
              )}
            </span>
          </span>
        ) : record?.slabRateType?.toLowerCase() === "fixed" ? (
          <span>{text}</span>
        ) : (
          <span>{text}%</span>
        );
      },
    },
  ];

  return (
    <Collapse collapsible={"header"} defaultActiveKey={["1"]}>
      <Panel header="Commission" key="1">
        <Row gutter={[16, 16]} className="equal-height-row">
          {rateCommission?.map((item, index) => (
            <Col span={8} key={index} className="equal-height-col">
              <Card
                className="equal-height-card"
                title={
                  commission?.past &&
                  item?.chargesHead !== item?.pastchargesHead ? (
                    <span className="high-light">
                      {item?.chargesHead}{" "}
                      <span className="ml-05 past-val">
                        {item?.pastchargesHead}
                      </span>
                    </span>
                  ) : (
                    <span>{item.chargesHead}</span>
                  )
                }
                bordered
              >
                <Table
                  dataSource={item.slab}
                  columns={columns}
                  pagination={false}
                  rowKey={(record, idx) => `${index}-${idx}`}
                  bordered
                  size="small"
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Panel>
    </Collapse>
  );
};

export default RateComission;
